import { SET_ACCOUNT_REP } from './types';

const initialState = {};

export const accountRepReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT_REP:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
